export default "__VITE_ASSET__Dxi7aBGE__"